import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-shipping-dialog',
  templateUrl: './shipping-dialog.component.html',
  styleUrls: ['./shipping-dialog.component.scss']
})
export class ShippingDialogComponent implements OnInit, OnDestroy {
  destroy$: Subject<void> = new Subject<void>();
  spin: boolean = false;
  shippingList:any[]=[]
  constructor(@Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<ShippingDialogComponent>,
  ) { }

  ngOnInit(): void {
    this.data.ordersShipingRateList = [
        {
          "serviceName": "FedEx First Overnight®",
          "serviceCode": "fedex_first_overnight",
          "shipmentCost": 87.8,
          "otherCost": 2.63,
          "imageUrl":"../../../assets/images/rc_one.png"
        },
        {
          "serviceName": "FedEx Priority Overnight®",
          "serviceCode": "fedex_priority_overnight",
          "shipmentCost": 50.23,
          "otherCost": 1.51,
          "imageUrl":'../../../assets/images/fbm-order-icon/usps-icon.svg'
        },
        {
          "serviceName": "FedEx Standard Overnight®",
          "serviceCode": "fedex_standard_overnight",
          "shipmentCost": 46.96,
          "otherCost": 1.41,
          "imageUrl":'../../../assets/images/rc_three.png'
        },
        {
          "serviceName": "FedEx 2Day® A.M.",
          "serviceCode": "fedex_2day_am",
          "shipmentCost": 23.04,
          "otherCost": 0.69,
          "imageUrl":'../../../assets/images/maersk-logo.png'
        },
        {
          "serviceName": "FedEx 2Day®",
          "serviceCode": "fedex_2day",
          "shipmentCost": 20.03,
          "otherCost": 0.6,
          "imageUrl":'../../../assets/images/rc_three.png'
        },
        {
          "serviceName": "FedEx Express Saver®",
          "serviceCode": "fedex_express_saver",
          "shipmentCost": 14.28,
          "otherCost": 0.43,
          "imageUrl":"../../../assets/images/rc_one.png"
        },
        {
          "serviceName": "FedEx Ground®",
          "serviceCode": "fedex_ground",
          "shipmentCost": 8.25,
          "otherCost": 0.33,
          "imageUrl":"../../../assets/images/rc_one.png"
        },
        {
          "serviceName": "FedEx Priority Overnight®",
          "serviceCode": "fedex_priority_overnight",
          "shipmentCost": 50.23,
          "otherCost": 1.51,
          "imageUrl":'../../../assets/images/fbm-order-icon/usps-icon.svg'
        },
        {
          "serviceName": "FedEx Standard Overnight®",
          "serviceCode": "fedex_standard_overnight",
          "shipmentCost": 46.96,
          "otherCost": 1.41,
          "imageUrl":'../../../assets/images/rc_three.png'
        },
        {
          "serviceName": "FedEx 2Day® A.M.",
          "serviceCode": "fedex_2day_am",
          "shipmentCost": 23.04,
          "otherCost": 0.69,
          "imageUrl":'../../../assets/images/maersk-logo.png'
        },
        {
          "serviceName": "FedEx 2Day®",
          "serviceCode": "fedex_2day",
          "shipmentCost": 20.03,
          "otherCost": 0.6,
          "imageUrl":'../../../assets/images/rc_three.png'
        },
    ]
    this.shippingList=this.data.ordersShipingRateList;
  }

  close() {
    this.dialogRef.close();
  }

  action(event) {
    if (event == "Confirm") {
      this.save();
    } else {
      this.close();
    }
  }

  onCheckboxChange(order: any) {
    this.shippingList.forEach((ele) => {
      if (ele.serviceName === order.serviceName) {
          ele.selected = true;
      }
    });
  }
  save() {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
